import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AuthService } from '../core';
import { ChatPanelService } from '../domains/aya/services/chat-panel.service';
import { RecursoService } from '../home/recurso/services/recurso.service';
import { ISidebarMenuItem } from './sidebar-menu/interfaces/sidebar-menu-item.interface';

@Component({
  selector: 'sgt-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit, OnDestroy {
  isSidebarMini = true;
  menuItems: ISidebarMenuItem[] = [];
  isMobileView = false;
  isChatOpen = false;

  private readonly MOBILE_BREAKPOINT = 990;
  private readonly SIDEBAR_WIDTH = 264;
  private readonly SIDEBAR_WIDTH_MINI = 68;
  private readonly AYA_ROUTE = '/ceppem-ai';

  get sidebarWidth(): number {
    if (this.isMobileView) {
      return this.SIDEBAR_WIDTH;
    }
    return this.isSidebarMini ? this.SIDEBAR_WIDTH_MINI : this.SIDEBAR_WIDTH;
  }
  private readonly destroy$ = new Subject<void>();

  constructor(
    public authService: AuthService,
    private recursoService: RecursoService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private chatPanelService: ChatPanelService
  ) {}

  ngOnInit() {
    this.checkMobileView();
    this.fetchMenuItems();

    this.isSidebarMini = this.isAyaRoute || this.isMobileView;

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      if (this.isMobileView || this.isAyaRoute) {
        this.closeSidebar();
      }
    });

    this.chatPanelService.getIsOpen$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isOpen => {
        this.isChatOpen = isOpen;
        this.cdr.markForCheck();
      });
  }

  private checkMobileView(): void {
    this.isMobileView = window.innerWidth < this.MOBILE_BREAKPOINT;
  }

  @HostListener('window:resize')
  onResize() {
    const wasMobile = this.isMobileView;
    this.checkMobileView();

    if (!wasMobile && this.isMobileView) {
      this.isSidebarMini = true;
    }

    this.cdr.markForCheck();
  }

  closeSidebar(): void {
    this.isSidebarMini = true;
    this.cdr.markForCheck();
  }

  fetchMenuItems(): void {
    this.recursoService.getRecursos().then(recursos => {
      const menuItems = this.recursoService.mapRecursosToMenuItems(recursos);
      this.menuItems = menuItems.filter(item => this.isMenuItemVisible(item));
    });
  }

  private isMenuItemVisible(item: ISidebarMenuItem): boolean {
    if (item.path === '/configuracoes') {
      return this.authService.podeAcessarCentralConfiguracoes();
    }
    return true;
  }

  onToggleSidebar(isMini: boolean) {
    this.isSidebarMini = isMini;
    this.cdr.markForCheck();
  }

  private get isAyaRoute(): boolean {
    return this.router.url.includes(this.AYA_ROUTE);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
